module.exports = __webpack_public_path__ + "static/media/genericCard.eba039ab.svg";